import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, Space } from "antd";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import type { MenuProps } from "antd";

import ProxyAccountModal from "../../../pages/ProxyAccount";

import {
	dropdownIcon,
	overlayTitle,
	menuItems,
	menuItemIcon,
	menuItemText,
	DropdownCloseCircle,
	menuItemsChangeAccount
} from "./styles";
import { Circle } from "../styles";

import {
	closeCircleImage,
	loginImage,
	repeatImage,
} from "../../../utils/staticImages";

import {
	DROPDOWN_LOGOUT,
	DROPDOWN_SWITCH_ACCOUNT,
} from "./constants";
import { IUserInfo } from "../constants";

import "./style.css";


interface HeaderDropdownProps {
	isDropdownActive: boolean;
	setDropdownStatus: (e: React.MouseEvent<HTMLElement>) => void;
	showOverlay: boolean;
	setShowOverlay: React.Dispatch<React.SetStateAction<boolean>>;
	hideOverlay: (e: React.MouseEvent<HTMLElement>) => void;
	userData: IUserInfo;
}

const HeaderDropdown: React.FC<HeaderDropdownProps> = ({
	setDropdownStatus,
	isDropdownActive,
	setShowOverlay,
	hideOverlay,
	showOverlay,
	userData,
}) => {
	const navigate = useNavigate();

	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleClick = (e: React.MouseEvent<HTMLElement>) => {
		hideOverlay(e);
		setDropdownStatus(e);
	};
	const handleProxyAccountClick = () => {
		setIsModalOpen(true);
	};

	const handleOk = () => {
		setIsModalOpen(false);
		setShowOverlay(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const logoutUser = () => {
		navigate("/accounts/logout");
		localStorage.clear();
	};

	const getInitials = (str: string) => {
		return str.split(" ").map(word => word[0]?.toUpperCase()).join("");
	};
	const userCode = getInitials(userData.name) + getInitials(userData.surname);


	const items: MenuProps["items"] = [
		{
			label: (
				<Space style={overlayTitle}>
					{userData.name + " " + userData.surname}
				</Space>
			),
			key: "0",
		},
		{
			label: (
				<Space onClick={handleProxyAccountClick} style={menuItemsChangeAccount}>
					<img
						style={menuItemIcon}
						src={repeatImage}
						alt="change-account"
					/>
					<span style={menuItemText}>{DROPDOWN_SWITCH_ACCOUNT}</span>
				</Space>
			),
			key: "1",
		},
		// {
		// 	label: (
		// 		<Space
		// 			onClick={handleClick}
		// 			style={{ ...menuItems, display: "none" }}
		// 		>
		// 			<img
		// 				style={menuItemIcon}
		// 				src={globalRefreshImage}
		// 				alt="change-language"
		// 			/>
		// 			<span style={menuItemText}>{DROPDOWN_LANGUAGE}</span>
		// 			<CaretDownOutlined
		// 				style={{
		// 					position: "absolute",
		// 					bottom: "30px",
		// 					right: "10px",
		// 				}}
		// 			/>
		// 		</Space>
		// 	),
		// 	key: "2",
		// },
		{
			label: (
				<Space onClick={logoutUser} style={menuItems}>
					<img style={menuItemIcon} src={loginImage} alt="logout" />
					<span style={menuItemText}>{DROPDOWN_LOGOUT}</span>
				</Space>
			),
			key: "2",
		},
		{
			label: (
				<Space onClick={handleClick}>
					<DropdownCloseCircle $background={closeCircleImage} />
				</Space>
			),
			key: "4",
		},
	];

	return (
		<>

			<Space style={{ padding: 0 }}>
				<Dropdown
					menu={{ items }}
					trigger={["click"]}
					overlayStyle={{ padding: 0, background: "transparent" }}
					overlayClassName="header-menu-overlay"
					onOpenChange={() => {
						setShowOverlay(true);
					}}
					open={showOverlay}
				>
					<Space>
						{isDropdownActive ? (
							<>
								<Circle
									$backgroundPhoto={userData?.profilePhoto}
									onClick={handleClick}
								>
									{!userData?.profilePhoto && userCode}
								</Circle>
								<CaretUpOutlined
									style={dropdownIcon}
									onClick={(e: React.MouseEvent<HTMLElement>) => {
										handleClick(e);
									}}
								/>
							</>
						) : (
							<>
								<Circle
									$backgroundPhoto={userData?.profilePhoto}
									onClick={setDropdownStatus}
								>
									{!userData?.profilePhoto && userCode}
								</Circle>
								<CaretDownOutlined
									style={dropdownIcon}
									onClick={setDropdownStatus}
								/>
							</>
						)}
					</Space>
				</Dropdown>
			</Space>

			<ProxyAccountModal
				modalTitle="Yeni Yetki Tanımlama"
				isModalOpen={isModalOpen}
				handleOk={handleOk}
				handleCancel={handleCancel}
			/>
		</>
	);
};

HeaderDropdown.propTypes = {
	setDropdownStatus: PropTypes.func.isRequired,
	isDropdownActive: PropTypes.bool.isRequired,
	showOverlay: PropTypes.bool.isRequired,
	setShowOverlay: PropTypes.func.isRequired,
	hideOverlay: PropTypes.func.isRequired,
};

export default HeaderDropdown;
